import ApiService from './api.service'

const GoodsService = {

	/**
	 * Store Warehouse Item
	 * @param data
	 * @returns {*}
	 */
	storeGood: function(data) {
		return ApiService.post(`/item/create`, data)
	},

	/**
	 * Store Warehouse Item
	 * @param data
	 * @returns {*}
	 */
	updateItem: function(id, data) {
		return ApiService.put(`/item/edit/${id}`, data)
	},


	/**
	 * List Warehouse Items
	 * @returns {*}
	 */
	fetchGoods: function(data){
		return ApiService.post(`/item/search/categories?page=${data.page}&limit=${data.limit}`,data.attributes)
	},
	fetchExcelGoods: function(data){
		return ApiService.post(`/item/download/excel`,data.attributes)
	},
	fetchGoodsForWrapped: function(data){
		return ApiService.post(`/item/search/add-wrapped-item?page=${data.page}&limit=${data.limit}`,data.attributes)
	},
	getFiltereGoodsForPos: function(data){
		return ApiService.post(`/item/search/list/pos?page=${data.page}&limit=${data.limit}`,data.attributes)
	},
	fetchGoodsWithKeyword: function(keyword){
		return ApiService.get(`item/search-by-keyword?keyword=${keyword}`)
	},
	fetchItemWithBarcode: function(barcode) {
		return ApiService.get(`item/get-by-barcode/${barcode}`)
	},
	fetchItemWithBarcodeNotIncomeService: function(payload) {
		return ApiService.get(`item/get-by-barcode-for-dep/${payload.barcode}/${payload.depId}`)
	},
	fetchGoodsForPos: function(keyword){
		return ApiService.get(`/pricing-item/search/${keyword}`)
	},
	fetchGoodsForWholesale: function(keyword){
		return ApiService.get(`/pricing-item/search/wholesale/${keyword}`)
	},

	deleteItem: function (id) {
		return ApiService.delete(`item/delete/${id}`);
	},
	setMainPhoto(itemId, photoId) {
		return ApiService.post(`item/${itemId}/mark-as-main-photo/${photoId}`)
	},
	getItemImages(itemId) {
		return ApiService.get(`item/photos-by-item/${itemId}`)
	},
	uploadPhoto: (id, formData) => {
		return ApiService.post(`item/upload/${id}`, formData)
	},
	deletePhoto: (itemId, photoId) => {
		return ApiService.post(`/item/${itemId}/remove-photo/${photoId}`)
	},

	setChild: (id, children) => {
		return ApiService.post(`item/wrap/${id}`, children)
	},

	byBarcode(barcode) {
		return ApiService.get(`item/get-by-barcode/${barcode}`).then(response => response.data)
	},

	pendingByBarcode(id, barcode) {
		return ApiService.get(`wh-document-item/update/transfer-doc/by-barcode/${id}/${barcode}`).then(response => response.data)
	},

	getItemsForPos() {
		return ApiService.get(`item/list-for-pos`)
	},

	getSearchForPos(data){
		return ApiService.post(`item/search/list/pos`,data)
	},
	getWrappedItemsByIdService(payload) {
		return ApiService.get(`wrapped-item/get-wrapped/${payload.itemId}/${payload.docId}`);
	},
	convertWrappedItems(payload) {
		return ApiService.post(`wrapped-item/convert-wrapped/${payload.depId}`, payload.whItems);
	}
};

export default GoodsService;
